import { ClientApplication } from './webapi/client/useApplicationQuery';
import { Offer } from './webapi/application/useFirstLoanOfferQuery';
import createFastContext from './createFastContext';

type BankId = {
  paymentAccounts?: Array<string>;
  sessionId?: string | null;
  error?: boolean;
  confirmed?: boolean;
};

type Store = {
  offer?: Offer;
  application?: ClientApplication;
  bankId?: BankId;
  is61DaysProduct?: boolean;
};

const { StoreProvider, useStore } = createFastContext<Store>({});

// TODO: Check if we can comply to this eslint rule
// eslint-disable-next-line react-refresh/only-export-components
export { StoreProvider, useStore };
